export default __webpack_public_path__ + "static/media/business-model-lean-canvas-template.b3011b87.pdf";